<template>
  <div class="container-fluid p-1">
    <div class="row">
      <div class="d-flex col-md-8 justify-content-between mx-auto mt-3">
        <h3 class="text-dark">Νέο Παιχνίδι</h3>
        <button v-if="!random && !startGame" class="btn btn-info"
          @click="random = true, player1Id = null, player2Id = null, player3Id = null, player4Id = null">Τυχαία
          <i class="bi bi-shuffle"></i></button>
        <button v-if="random && !startGame" class="d-inline btn btn-outline-info"
          @click="random = false, player1Id = null, player2Id = null, player3Id = null, player4Id = null">Ακύρωση</button>
        <div v-if="startGame" class="">
          <Modal :btnClass="'btn btn-info'" :buttonText="'Διαγραφή ' + `<i class='fas fa-trash'></i>`"
            :title="'Διαγραφή Παιχνιδιού;'" :modalId="'resetModal'" ref="closeResetModal" @handleClick="handleReset" />
        </div>
      </div>
      <Spinner v-if="isPending" color="primary" />
      <div v-else class="col-md-8 mx-auto">
        <div v-if="!startGame">
          <div v-if="random">
            <div class="row justify-content-start">
              <div class="my-2 d-flex justify-content-between">
                <h4 class="d-inline text-start">Τυχαία Επιλογή:</h4>
                <!-- <button class="d-inline btn btn-outline-info"
                  @click="random = false, player1Id = null, player2Id = null, player3Id = null, player4Id = null">Ακύρωση</button> -->
              </div>
              <div class="col-md-3 my-2 input-group">
                <label class="input-group-text" for="selectP1">Παίκτης 1</label>
                <select class="form-select" id="selectP1" v-model="player1Id"
                  @change="player2Id = null, player3Id = null, player4Id = null">
                  <option class="form-select" v-for="(player, index) in players" :key="player.id" :value="player.id">{{
                    player.name
                  }}</option>
                </select>
              </div>
              <div class="col-md-3 my-2 input-group">
                <label class="input-group-text" for="selectP1">Παίκτης 2</label>
                <select class="form-select" id="selectP1" v-model="player2Id" @change="player3Id = null, player4Id = null"
                  :disabled="!player1Id">
                  <option class="form-select" v-for="(player, index) in filtP2" :key="player.id" :value="player.id">{{
                    player.name
                  }}</option>
                </select>
              </div>
              <div class="col-md-3 my-2 input-group">
                <label class="input-group-text" for="selectP1">Παίκτης 3</label>
                <select class="form-select" id="selectP1" v-model="player3Id" @change="player4Id = null"
                  :disabled="!player2Id">
                  <option class="form-select" v-for="(player, index) in filtP3" :key="player.id" :value="player.id">{{
                    player.name
                  }}</option>
                </select>
              </div>
              <div class="col-md-3 my-2 input-group">
                <label class="input-group-text" for="selectP1">Παίκτης 4</label>
                <select class="form-select" id="selectP1" v-model="player4Id" @change="randomGame" :disabled="!player3Id">
                  <option class="form-select" v-for="(player, index) in filtP4" :key="player.id" :value="player.id">{{
                    player.name
                  }}</option>
                </select>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="row justify-content-center">
              <div class="my-2">
                <h4 class="text-center">Ομάδα 1:</h4>
              </div>
              <div class="col-md-6 my-2 input-group">
                <label class="input-group-text" for="selectP1">Παίκτης 1</label>
                <select class="form-select" id="selectP1" v-model="player1Id" @change="player2Id = null">
                  <option class="form-select list-group-item list-group-item-action" v-for="(player, index) in players"
                    :key="player.id" :value="player.id">{{ player.name }}</option>
                </select>
              </div>
              <div class="col-md-6 my-2 input-group">
                <label class="input-group-text" for="selectP2">Παίκτης 2</label>
                <select class="form-select" id="selectP2" v-model="player2Id" @change="handleP2change"
                  :disabled="!player1Id">
                  <option class="form-select" v-for="(player, index) in filtP2" :key="player.id" :value="player.id">{{
                    player.name
                  }}</option>
                </select>
              </div>
            </div>
            <div v-if="player2Id" class="row justify-content-center">
              <div class="my-2">
                <h4 class="text-center">Ομάδα 2:</h4>
              </div>
              <div class="col-md-6 my-2 input-group">
                <label class="input-group-text" for="selectP3">Παίκτης 1</label>
                <select class="form-select" id="selectP3" v-model="player3Id" @change="player4Id = null">
                  <option class="form-select" v-for="(player, index) in filtP3" :key="player.id" :value="player.id">{{
                    player.name
                  }}</option>
                </select>
              </div>
              <div class="col-md-6 my-2 input-group">
                <label class="input-group-text" for="selectP4">Παίκτης 2</label>
                <select class="form-select" id="selectP4" v-model="player4Id" @change="handleP4change"
                  :disabled="!player3Id">
                  <option class="form-select" v-for="(player, index) in filtP4" :key="player.id" :value="player.id">{{
                    player.name
                  }}</option>
                </select>
              </div>
            </div>
          </div>
          <div v-if="player4Id" class="col-md-8 justify-content-center">
            <button class="btn btn-primary" @click="handleStart">Έναρξη</button>
          </div>
        </div>
        <transition v-if="startGame">
          <div class="justify-content-center">
            <div class="row d-flex justify-content-center mt-3 mb-3 px-3">
              <div class="mb-4">
                <!-- tabs from bootstrap -->
                <ul class="nav nav-pills" id="myTab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button class="nav-link active" id="score-tab" data-bs-toggle="tab" data-bs-target="#score"
                      type="button" role="tab" aria-controls="score" aria-selected="true">Σκορ</button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button class="nav-link" id="stats-tab" data-bs-toggle="tab" data-bs-target="#stats" type="button"
                      role="tab" aria-controls="stats" aria-selected="false">Στατιστικά</button>
                  </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active" id="score" role="tabpanel" aria-labelledby="score-tab">
                    <div class="row fw-bold">
                      <div class="col-2 border p-2">#</div>
                      <div class="col-4 border p-2">
                        <span v-if="player1Id === dealer"><img src="../../public/dealer.png" alt="dealer-img"
                            class="img-thumbnail mx-1 img-responsive img-fluid" style="max-width: 30px"></span>{{
                              player1.name }} - {{ player2.name }}<span v-if="player2Id === dealer"><img
                            src="../../public/dealer.png" alt="dealer-img"
                            class="img-thumbnail mx-1 img-responsive img-fluid" style="max-width: 30px"></span>
                      </div>
                      <div class="col-4 border p-2">
                        <span v-if="player3Id === dealer"><img src="../../public/dealer.png" alt="dealer-img"
                            class="img-thumbnail mx-1 img-responsive img-fluid" style="max-width: 30px"></span>{{
                              player3.name }} - {{ player4.name }}<span v-if="player4Id === dealer"><img
                            src="../../public/dealer.png" alt="dealer-img"
                            class="img-thumbnail mx-1 img-responsive img-fluid" style="max-width: 30px"></span>
                      </div>
                      <div class="col-2 border p-2"></div>
                    </div>
                    <transition-group name="lot">
                      <div class="row" v-for="(lot, index) in game.lots" :key="index">
                        <div class="col-2 border p-2">{{ index + 1 }}</div>
                        <div class="col-4 border p-2">{{ lot.score1 }}</div>
                        <div class="col-4 border p-2">{{ lot.score2 }}</div>
                        <i type="button" class="col-2 btn-outline-danger border bi bi-x-lg p-2" style="cursor: pointer"
                          data-bs-toggle="modal" :data-bs-target="`#removeLotModal${index}`"></i>
                        <teleport to="body">
                          <div class="modal fade" :id="`removeLotModal${index}`" tabindex="-1" aria-labelledby="modal"
                            aria-hidden="true">
                            <div class="modal-dialog">
                              <div class="modal-content">
                                <div class="modal-header">
                                  <h5 class="modal-title" id="modalTitle">Αφαίρεση παρτίδας</h5>
                                  <button type="button" class="btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                                </div>
                                <div class="modal-footer d-flex justify-content-center">
                                  <button type="button" class="btn btn-outline-danger px-4" @click="removeLot(index)"
                                    data-bs-dismiss="modal">ΝΑΙ</button>
                                  <button class="visually-hidden" type="button" data-bs-dismiss="modal"></button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </teleport>
                      </div>
                    </transition-group>
                    <div class="row fw-bold">
                      <div class="col-2 border p-2">Συν:</div>
                      <div class="col-4 border p-2">{{ sum1 }}</div>
                      <div class="col-4 border p-2">{{ sum2 }}</div>
                      <div class="col-2 border p-2"></div>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="stats" role="tabpanel" aria-labelledby="stats-tab">
                    <div class="row fw-bold d-flex flex-nowrap">
                      <div class="col-2 border p-2 w-40px">#</div>
                      <div class="col border p-2 w-40px">{{ player1.name.slice(0, 4) }}</div>
                      <div class="col border p-2 w-40px">{{ player2.name.slice(0, 4) }}</div>
                      <div class="col border p-2 w-40px">{{ player3.name.slice(0, 4) }}</div>
                      <div class="col border p-2 w-40px">{{ player4.name.slice(0, 4) }}</div>
                    </div>
                    <div class="row d-flex flex-nowrap" v-for="(lot, index) in game.lots" :key="index">
                      <div class="col-2 border p-2 w-40px">{{ index + 1 }}</div>
                      <div class="col border p-2 w-40px">
                        <img v-if="lot.dekakalo == player1.id" src="../../public/10-diamond.png" alt="10-diamond"
                          class="img-thumbnail mx-auto img-responsive img-fluid" style="max-width: 30px" />
                      </div>
                      <div class="col border p-2 w-40px">
                        <img v-if="lot.dekakalo == player2.id" src="../../public/10-diamond.png" alt="10-diamond"
                          class="img-thumbnail mx-auto img-responsive img-fluid" style="max-width: 30px" />
                      </div>
                      <div class="col border p-2 w-40px">
                        <img v-if="lot.dekakalo == player3.id" src="../../public/10-diamond.png" alt="10-diamond"
                          class="img-thumbnail mx-auto img-responsive img-fluid" style="max-width: 30px" />
                      </div>
                      <div class="col border p-2 w-40px">
                        <img v-if="lot.dekakalo == player4.id" src="../../public/10-diamond.png" alt="10-diamond"
                          class="img-thumbnail mx-auto img-responsive img-fluid" style="max-width: 30px" />
                      </div>
                    </div>
                    <div class="row fw-bold d-flex flex-nowrap">
                      <div class="col-2 border p-2 w-40px">%</div>
                      <div class="col border p-2 w-40px">{{ Math.floor(dekaP1) }}</div>
                      <div class="col border p-2 w-40px">{{ Math.floor(dekaP2) }}</div>
                      <div class="col border p-2 w-40px">{{ Math.floor(dekaP3) }}</div>
                      <div class="col border p-2 w-40px">{{ Math.floor(dekaP4) }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- add form to submit every lot of the game -->
              <form class="mx-4 pt-3 shadow rounded" @submit.prevent="addLot">
                <div class="col d-flex mb-3 p-1 border justify-content-around">
                  <label for="score1" class="col-6 col-form-label">{{ player1.name }} - {{ player2.name }}</label>
                  <input type="number" class="col-3" id="score1" v-model="scoreLot1" placeholder="0" />
                </div>
                <div class="col d-flex mb-3 p-1 border justify-content-around">
                  <label for="score2" class="col-6 col-form-label">{{ player3.name }} - {{ player4.name }}</label>
                  <input type="number" class="col-3" id="score2" v-model="scoreLot2" placeholder="0" />
                </div>
                <div class="col d-flex mb-3 p-2 border align-items-center">
                  <div class="col text-end">
                    <div class="m-2">
                      <input class="btn-check" type="radio" name="gridRadios" id="gridRadios1" :value="player1.id"
                        v-model="dekaKalo" />
                      <label class="w-100 btn btn-outline-danger" for="gridRadios1">
                        {{
                          player1.name
                        }}
                      </label>
                    </div>
                    <div class="m-2">
                      <input class="btn-check" type="radio" name="gridRadios" id="gridRadios2" :value="player2.id"
                        v-model="dekaKalo" />
                      <label class="w-100 btn btn-outline-danger" for="gridRadios2">
                        {{
                          player2.name
                        }}
                      </label>
                    </div>
                  </div>
                  <div class="col-2">
                    <img src="../../public/10-diamond.png" alt="10-diamond"
                      class="img-thumbnail mx-auto img-responsive img-fluid" />
                  </div>
                  <div class="col text-start">
                    <div class="m-2">
                      <input class="btn-check" type="radio" name="gridRadios" id="gridRadios3" :value="player3.id"
                        v-model="dekaKalo" />
                      <label class="w-100 btn btn-outline-danger" for="gridRadios3">
                        {{
                          player3.name
                        }}
                      </label>
                    </div>
                    <div class="m-2">
                      <input class="btn-check" type="radio" name="gridRadios" id="gridRadios4" :value="player4.id"
                        v-model="dekaKalo" />
                      <label class="w-100 btn btn-outline-danger" for="gridRadios4">
                        {{
                          player4.name
                        }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <button type="submit" class="col w-100 btn btn-success mb-3">Προσθήκη παρτίδας</button>
                </div>
              </form>
            </div>
            <div class="row justify-content-center">
              <!-- <div class="col-md-3 mb-3">
                <Modal :btnClass="'btn btn-info'" :buttonText="'Reset game'" :title="'Διαγραφή Παιχνιδιού;'"
                  :modalId="'resetModal'" ref="closeResetModal" @handleClick="handleReset" />
              </div> -->
              <div class="col-md-4">
                <Modal :btnClass="'btn btn-outline-danger'" :buttonText="'Τέλος Παιχνιδιού'"
                  :title="'Τερματισμός Παιχνιδιού;'" :modalId="'endGameModal'" ref="closeEndGameModal"
                  @handleClick="addData" />
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, ref } from "@vue/reactivity";
import { watchEffect, onUnmounted } from "vue";
// @ is an alias to /src
import { db } from "../firebase/config";
import {
  doc,
  collection,
  getDocs,
  addDoc,
  getDoc,
  updateDoc,
  deleteDoc,
  increment,
  serverTimestamp,
  onSnapshot,
  arrayUnion,
  writeBatch,
setDoc
} from "firebase/firestore";
import Lot from "../components/Lot.vue";
import Modal from "../components/Modal.vue";
import Spinner from "../components/Spinner.vue";
// import fetchUser from "../composables/fetchUser"
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import getSeasons from "../composables/getSeasons";
import { start } from "repl";

export default {
  name: "NewGame",
  components: { Lot, Modal, Spinner },
  setup(props) {
    const store = useStore();
    store.commit('setSidebarToggle', true)

    const batch = writeBatch(db);
    const user = computed(() => {
      return store.state.user;
    });
    const seasons = computed(() => {
      return store.state.season;
    });
    const allTeams = computed(() => {
      return store.state.teams;
    });
    const teams = computed(() => {
      return store.state.totalTeams;
    });
    const players = computed(() => {
      return store.state.totalPlayers;
    });
    const player1Id = ref();
    const player2Id = ref();
    const player3Id = ref();
    const player4Id = ref();
    const dealer = ref();
    const player1 = ref();
    const player2 = ref();
    const player3 = ref();
    const player4 = ref();
    const addedTeam = ref();
    const team1 = ref();
    const team2 = ref();
    const scoreLot1 = ref(null);
    const scoreLot2 = ref(null);
    const dekaKalo = ref([]);
    const lots = ref([]);
    const game = ref();
    const startGame = ref(false)
    const toggleAddTeam = ref(false);
    const toggleReset = ref(false);
    const toggleEndGame = ref(false);
    const spinner = ref(false);
    const random = ref(false)
    const closeModal = ref(null);
    const closeResetModal = ref(null);
    const closeEndGameModal = ref(null);
    const router = useRouter();
    const route = useRoute();
    const error = computed(() => {
      return store.state.error;
    });
    const isPending = computed(() => {
      return store.state.isPending;
    });

    let colRefTeams;
    let colRefPlayers;
    let colRefGames;
    let refGame;
    let getTeams;
    let gameId = route.query.id || null;

    // filter player2 list from player1 value
    const filtP2 = computed(() => {
      if (player1Id.value) {
        const { [player1Id.value]: _, ...filtered } = players.value
        return filtered
        // return players.value.filter((player) => player.id !== player1Id.value);
      }
    });

    // filter player3 list from filtP2
    const filtP3 = computed(() => {
      if (player2Id.value) {
        const { [player2Id.value]: _, ...filtered } = filtP2.value
        return filtered
        // return filtP2.value.filter((player) => player.id !== player2Id.value);
      }
    });

    // filter player4 list from filtP3
    const filtP4 = computed(() => {
      if (player3Id.value) {
        const { [player3Id.value]: _, ...filtered } = filtP3.value
        return filtered
        // return filtP3.value.filter((player) => player.id !== player3Id.value);
      }
    });

    // calculate total score for each team
    const sum1 = computed(() => {
      if (game.value.lots.length) {
        return game.value.lots
          .map((lot) => lot.score1)
          .reduce((prev, next) => prev + next);
      } else return 0;
    });
    const sum2 = computed(() => {
      if (game.value.lots.length) {
        return game.value.lots
          .map((lot) => lot.score2)
          .reduce((prev, next) => prev + next);
      } else return 0;
    });

    // calculate 10kalo percentage
    const dekaP1 = computed(() => {
      if (game.value.lots.length) {
        const count = game.value.lots.filter((lot) => lot.dekakalo === player1.value.id)
          .length;
        return ((count / game.value.lots.length) * 100).toFixed(2); // multiply by 100 and cut to two decimal numbers
      } else return 0;
    });
    const dekaP2 = computed(() => {
      if (game.value.lots.length) {
        const count = game.value.lots.filter((lot) => lot.dekakalo === player2.value.id)
          .length;
        return ((count / game.value.lots.length) * 100).toFixed(2);
      } else return 0;
    });
    const dekaP3 = computed(() => {
      if (game.value.lots.length) {
        const count = game.value.lots.filter((lot) => lot.dekakalo === player3.value.id)
          .length;
        return ((count / game.value.lots.length) * 100).toFixed(2);
      } else return 0;
    });
    const dekaP4 = computed(() => {
      if (game.value.lots.length) {
        const count = game.value.lots.filter((lot) => lot.dekakalo === player4.value.id)
          .length;
        return ((count / game.value.lots.length) * 100).toFixed(2);
      } else return 0;
    });

    // add new lot to lots array
    const addLot = async () => {
      refGame = await doc(db, "season", seasons.value[0].id, "games", gameId); //!!! restore to seasons.value[0]

      let lots = game.value.lots
      lots.push({
        score1: scoreLot1.value || 0, // add team1 score or 0 if nothing entered
        score2: scoreLot2.value || 0,
        dekakalo: dekaKalo.value,
      })

      await updateDoc(refGame, {
        lots: lots,
        "team1.sum": sum1.value, // the sum is not updated before current scoreLot is added 
        "team2.sum": sum2.value
      });

      scoreLot1.value = null;
      scoreLot2.value = null;
      dekaKalo.value = [];
    };

    // remove lot with the specific index from lots array
    const removeLot = async (index) => {
      refGame = await doc(db, "season", seasons.value[0].id, "games", gameId); //!!! restore to seasons.value[0]
      game.value.lots.splice(index, 1);
      await updateDoc(refGame, {
        lots: game.value.lots,
        "team1.sum": sum1.value,
        "team2.sum": sum2.value
      });
    };

    //add data to database
    const addData = async () => {
      // spinner.value = true;
      //
      if (sum1.value === sum2.value) {
        store.commit("setError", "Το παιχνίδι δεν μπορεί να λήξει ισόπαλο...!");
        store.commit('setAlertColor', 'alert-danger')
        // call function closeMdl of #endGameModal to close modal
        closeEndGameModal.value.closeMdl();
        spinner.value = false;
        return;
      }
      // check if team 1 won
      const winnerTeam1 = sum1.value > sum2.value ? true : false;
      game.value = {
        live: false,
        lots: game.value.lots,
        dealer: dealer.value,
        team1: {
          id: team1.value.id,
          player1: team1.value.player1,
          player2: team1.value.player2,
          win: winnerTeam1,
          sum: sum1.value,
        },
        team2: {
          id: team2.value.id,
          player1: team2.value.player1,
          player2: team2.value.player2,
          win: !winnerTeam1,
          sum: sum2.value,
        },
        timestamp: serverTimestamp()
      };

      refGame = await doc(db, "season", seasons.value[0].id, "games", gameId);
      await updateDoc(refGame, {
        live: false,
        lots: game.value.lots,
        dealer: dealer.value,
        team1: {
          id: team1.value.id,
          player1: team1.value.player1,
          player2: team1.value.player2,
          win: (sum1.value > sum2.value),
          sum: sum1.value,
        },
        team2: {
          id: team2.value.id,
          player1: team2.value.player1,
          player2: team2.value.player2,
          win: (sum1.value < sum2.value),
          sum: sum2.value,
        },
        timestamp: serverTimestamp()
      }).then(() => {
        if (winnerTeam1) {
          updateDocs(team1.value, team2.value); // call updateDocs to update wins and loses
        } else if (!winnerTeam1) {
          let tempPlayer = player1.value
          player1.value = player3.value
          player3.value = tempPlayer
          tempPlayer = player2.value
          player2.value = player4.value
          player4.value = tempPlayer
          updateDocs(team2.value, team1.value);
        }
      })

      // try {
      //   error.value = null
      //   // add new document under games collection and retrieve the id
      //   const docRef = await addDoc(colRefGames, game).then((docRef) => {
      //     gameId = docRef.id
      //   })
      // } catch (err) {
      //   error.value = err.message
      // }




    };

    // function to update wins and loses for each player and team
    const updateDocs = async (team1, team2) => {
      try {
        // error.value = null
        store.commit("setError", null);
        // refGame = await doc(db, "season", seasons.value[0].id, "games", gameId);        
        // batch.update(refGame, {
        //   live: false,
        //   lots: game.value.lots,
        //   team1: {
        //     id: team1.id,
        //     player1: team1.player1,
        //     player2: team1.player2,
        //     win: (sum1.value > sum2.value),
        //     sum: sum1.value,
        //   },
        //   team2: {
        //     id: team2.id,
        //     player1: team2.player1,
        //     player2: team2.player2,
        //     win: (sum1.value < sum2.value),
        //     sum: sum2.value,
        //   },
        //   timestamp: serverTimestamp()
        // });

        batch.update(doc(db, "season", seasons.value[0].id, "players", team1.player1.id), { wins: increment(1) })
        batch.update(doc(db, "season", seasons.value[0].id, "players", team1.player2.id), { wins: increment(1) })
        batch.update(doc(db, "season", seasons.value[0].id, "players", team2.player1.id), { loses: increment(1) })
        batch.update(doc(db, "season", seasons.value[0].id, "players", team2.player2.id), { loses: increment(1) })
        batch.update(doc(db, "season", seasons.value[0].id, "teams", team1.id), { wins: increment(1) })
        batch.update(doc(db, "season", seasons.value[0].id, "teams", team2.id), { loses: increment(1) })
        // batch.update(doc(db, "users", player1.value.user.id), { wins: increment(1) })
        // batch.update(doc(db, "users", player2.value.user.id), { wins: increment(1) })
        // batch.update(doc(db, "users", player3.value.user.id), { loses: increment(1) })
        // batch.update(doc(db, "users", player4.value.user.id), { loses: increment(1) })
        // batch.update(doc(db, "teams", team1.team.id), { wins: increment(1) })
        // batch.update(doc(db, "teams", team2.team.id), { loses: increment(1) })
        await batch.commit()



        // call function closeMdl of #endGameModal to close modal
        closeEndGameModal.value.closeMdl();

        // redirect to Game details
        router.push({ name: "GameDetails", params: { id: gameId } });
        spinner.value = false;

        // initialize all variables
        startGame.value = false
        lots.value = [];
        team1.value = null;
        team2.value = null;
        player1.value = null;
        player2.value = null;
        player3.value = null;
        player4.value = null;
        player1Id.value = null;
        player2Id.value = null;
        player3Id.value = null;
        player4Id.value = null;
        scoreLot1.value = null;
        scoreLot2.value = null;
        dekaKalo.value = [];
        // error.value = null
        store.commit("setError", null);

        store.dispatch('seasonStats', seasons.value[0].id)
      } catch (err) {
        // error.value = err.message
        store.commit("setError", err.message);
      }
    };

    // add team to db
    const addTeam = async (p1, p2, teamRef) => {
      let teamName = "";
      const player1Ref = doc(db, "season", seasons.value[0].id, "players", p1);
      const player2Ref = doc(db, "season", seasons.value[0].id, "players", p2);
      colRefTeams = collection(db, "season", seasons.value[0].id, "teams");
      teamName = players.value[p1].name + "-" + players.value[p2].name
      // await getDoc(player1Ref).then((docSnap) => {
      //   let name = docSnap.data().name;
      //   teamName = name;
      // });
      // await getDoc(player2Ref).then((docSnap) => {
      //   let name = docSnap.data().name;
      //   teamName = teamName + "-" + name;
      // });

      try {
        store.commit("setError", null);

        const team = {
          name: teamName,
          player1: player1Ref,
          player2: player2Ref,
          wins: 0,
          loses: 0,
          team: teamRef
        }

        // Add team to the season with the same id as the teamRef
        // const docRef = await addDoc(colRefTeams, team).then((docSnap) => {
          const docRef = await setDoc(doc(db, "season", seasons.value[0].id, "teams", teamRef.id), team)
          // .then((docSnap) => {
          // store.dispatch('getTeams', colRefTeams)
          store.commit('setTotalTeams', { ...teams.value, [teamRef.id]: { ...team, id: teamRef.id } })
          store.commit('setUnorderedTeams', { ...teams.value, [teamRef.id]: { ...team, id: teamRef.id } })
          addedTeam.value = teams.value[teamRef.id];

        // });
      } catch (err) {
        store.commit("setError", err.message);
      }
      console.log("Team added in db:", addedTeam.value);
    };

    //get team from vuex store
    const getTeamFunction = async (p1, p2) => {
      let getTeam = {};
      let getGlobalTeam = {};
      getTeam = Object.values(teams.value)
        .filter(
          (team) =>
            team.player1.id === p1 || team.player1.id === p2
        )
        .filter(
          (team) =>
            team.player2.id === p1 || team.player2.id === p2
        )[0];
      if (!getTeam) {
        getGlobalTeam = Object.values(allTeams.value)
          .filter(
            (team) =>
              team.player1.id === p1 || team.player1.id === p2
          )
          .filter(
            (team) =>
              team.player2.id === p1 || team.player2.id === p2
          )[0];
        if (!getGlobalTeam) {
          const colTeams = collection(db, "teams");
          const player1 = players.value[p1];
          const player2 = players.value[p2];
          await addDoc(colTeams, {
            player1: player1.user,
            player2: player2.user,
            wins: 0,
            loses: 0
          }).then(async (res) => {
            const getTeamRef = doc(db, "teams", res.id);
            await addTeam(p1, p2, getTeamRef).then(() => {
              getTeam = addedTeam.value;
            });
          });
        } else {
          try {
            store.commit("setError", null);
            const getTeamRef = doc(db, "teams", getGlobalTeam.id);

            // call addTeam to add the team to the db if it does not exist
            await addTeam(p1, p2, getTeamRef).then(() => {
              getTeam = addedTeam.value;
            });
          } catch (err) {
            store.commit("setError", err.message);
          }
        }
      }

      return getTeam;
    }

    const handleP2change = async () => {
      player3Id.value = null;
      team1.value = await getTeamFunction(player1Id.value, player2Id.value)
    };

    const handleP4change = async () => {
      team2.value = await getTeamFunction(player3Id.value, player4Id.value);
    };

    const handleStart = async () => {
      if (!user.value.verified) {
        console.log("not verified");
        store.commit("setError", "Δεν είστε πιστοποιημένος χρήστης. Επικοινωνήστε με τον διαχειριστή...");
        store.commit('setAlertColor', 'alert-danger')
        return
      }
      startGame.value = true
      // retrieve each player from players array
      player1.value = players.value[player1Id.value];
      player2.value = players.value[player2Id.value];
      player3.value = players.value[player3Id.value];
      player4.value = players.value[player4Id.value];

      // random who deals first
      const playersTable = [player1Id.value, player2Id.value, player3Id.value, player4Id.value]
      const random = Math.floor(Math.random() * playersTable.length)
      dealer.value = playersTable[random]

      game.value = {
        live: true,
        creator: user.value.uid,
        lots: [],
        dealer: dealer.value,
        team1: {
          id: team1.value.id,
          player1: team1.value.player1,
          player2: team1.value.player2,
        },
        team2: {
          id: team2.value.id,
          player1: team2.value.player1,
          player2: team2.value.player2,
        },
        timestamp: serverTimestamp(),
      };


      await addDoc(
        collection(db, "season", seasons.value[0].id, "games"),
        game.value
      ).then((docRef) => {
        gameId = docRef.id;
      });

      await onSnapshot(
        doc(db, "season", seasons.value[0].id, "games", gameId),
        (snapshot) => {
          if (snapshot.data()) {
            game.value = snapshot.data();
          } else {
            resetValues()
            store.commit("setIsPending", false);
            router.push("/new-game")
            store.commit("setError", "Το παιχνίδι διαγράφηκε!");
            store.commit('setAlertColor', 'alert-danger')
          }
        }
      );

      router.push(`/new-game?id=${gameId}`);
    }

    const randomGame = async () => {
      store.commit('setIsPending', true)
      let randomize = [player1Id.value, player2Id.value, player3Id.value, player4Id.value]

      // Johnaras - Salino always team-up
      let johnaras = "wFRqduJpPzRKYLtsYgqGgh0bSga2"
      let salino = "YUbzIbilTTbXaP2hw4xhPbKYXMB2"

      const timer = ms => new Promise(res => setTimeout(res, ms))
      let currentIndex = randomize.length - 1, randomIndex;

      async function load() { // We need to wrap the loop into an async function for this to work
        // make shuffling animation by alternating players Ids with every loop
        let i = 20;
        while (i != 0) {
          // Pick a remaining element...
          randomIndex = Math.floor(Math.random() * currentIndex);
          i--;
          // And swap it with the current element.
          [randomize[currentIndex], randomize[randomIndex]] = [
            randomize[randomIndex], randomize[currentIndex]];

          player1Id.value = randomize[0]
          player2Id.value = randomize[1]
          player3Id.value = randomize[2]
          player4Id.value = randomize[3]

          await timer(20); // then the created Promise can be awaited
        }
        // }
      }

      const checkPlayers = () => {
        return new Promise((res) => {
          // Johnaras - Salino always team-up
          if (randomize.includes(johnaras) && randomize.includes(salino)) {
            load().then(() => {
              let tempTable = randomize.filter((id => id !== johnaras)).filter((id => id !== salino))
              // console.log(tempTable);
              let johnarasIndex = randomize.indexOf(johnaras);
              let salinoIndex = randomize.indexOf(salino);
              let random_boolean = Math.random() < 0.5;
              if (random_boolean) {
                // let temp = randomize[0];
                // randomize[0] = randomize[johnarasIndex];
                // randomize[johnarasIndex] = temp;
                // temp = randomize[1];
                // randomize[1] = randomize[salinoIndex];
                // randomize[salinoIndex] = temp;
                randomize[0] = johnaras;
                randomize[1] = salino;
                randomize[2] = tempTable[0];
                randomize[3] = tempTable[1];
              } else {
                // let temp = randomize[2];
                // randomize[2] = randomize[johnarasIndex];
                // randomize[johnarasIndex] = temp;
                // temp = randomize[3];
                // randomize[3] = randomize[salinoIndex];
                // randomize[salinoIndex] = temp;

                randomize[0] = tempTable[0];
                randomize[1] = tempTable[1];
                randomize[2] = johnaras;
                randomize[3] = salino;
              }

              player1Id.value = randomize[0]
              player2Id.value = randomize[1]
              player3Id.value = randomize[2]
              player4Id.value = randomize[3]

              res();

            })

          } else {
            // Returns a Promise that resolves after "ms" Milliseconds

            load().then(() => {
              player1Id.value = randomize[0]
              player2Id.value = randomize[1]
              player3Id.value = randomize[2]
              player4Id.value = randomize[3]
              res();
            })

          }

        })

      }

      checkPlayers().then(async () => {
        team1.value = await getTeamFunction(player1Id.value, player2Id.value);
        team2.value = await getTeamFunction(player3Id.value, player4Id.value);
        // getTeamsRandom();

      })


      store.commit('setIsPending', false)
    }

    const handleReset = async () => {
      closeResetModal.value.closeMdl(); // call function closeMdl of #resetModal to close modal
      await deleteDoc(doc(db, 'season', seasons.value[0].id, 'games', gameId))
      router.push("/new-game")
      resetValues()
      store.commit("setError", null);
    }

    // reset all values
    const resetValues = () => {
      gameId = null;
      game.value = null;
      lots.value = [];
      team1.value = null;
      team2.value = null;
      player1.value = null;
      player2.value = null;
      player3.value = null;
      player4.value = null;
      player1Id.value = null;
      player2Id.value = null;
      player3Id.value = null;
      player4Id.value = null;
      scoreLot1.value = null;
      scoreLot2.value = null;
      dekaKalo.value = [];
      startGame.value = false
    }

    const stopWatch = watchEffect(() => {
      console.log(!!route.query.id);
      if (!!route.query.id) {
        const colRefGame = doc(db, "season", seasons.value[0].id, "games", route.query.id);
        getDoc(colRefGame).then((snapshot) => {
          if(!snapshot.data()) {
            router.push("/new-game")
          }
        });
      }
    })

    // get game id from route.query to rematch game with the same teams
    const rematch = route.query.id || null;
    if (rematch) {
      // redirect to GameDetails if season id is not ready
      if (!seasons.value.length) {
        router.push("/game/" + rematch);
        return;
      }
      // error.value = null
      // isPending.value = true
      store.commit("setIsPending", true);
      const load = async () => {
        const colRefGame = doc(db, "season", seasons.value[0].id, "games", rematch); //!!! restore to seasons.value[0]
        // await updateDoc(colRefGame, {
        //   live: true
        // })
        getDoc(colRefGame).then((snapshot) => {
          game.value = snapshot.data();
          console.log(!!game.value);
          if (!!game.value) {
            // check if game has finished and redirect to GameDetails
            let finishedGame = !!game.value.team1.win || !!game.value.team2.win
            console.log(finishedGame);
            if (!game.value.live || finishedGame) {
              updateDoc(colRefGame, {
                live: false
              })
              router.push("/game/" + rematch);
              return;
            }
            loadGame(rematch);
          } else {
            resetValues()
            store.commit("setIsPending", false);
            router.push("/new-game")
          }
        });
      };
      load();

      const loadGame = async (rematch) => {
        try {
          store.commit("setError", null);
          team1.value = teams.value[game.value.team1.id]
          team2.value = teams.value[game.value.team2.id]
          player1.value = players.value[team1.value.player1.id]
          player2.value = players.value[team1.value.player2.id]
          player3.value = players.value[team2.value.player1.id]
          player4.value = players.value[team2.value.player2.id]
          player1Id.value = player1.value.id;
          player2Id.value = player2.value.id;
          player3Id.value = player3.value.id;
          player4Id.value = player4.value.id;
          dealer.value = game.value.dealer
          startGame.value = true

          await onSnapshot(
            doc(db, "season", seasons.value[0].id, "games", rematch),
            (snapshot) => {
              if (snapshot.data()) {
                game.value = snapshot.data();
              } else {
                resetValues()
                store.commit("setIsPending", false);
                router.push("/new-game")
                store.commit("setError", "Το παιχνίδι διαγράφηκε!");
                store.commit('setAlertColor', 'alert-danger')
              }
            }
          );

          // isPending.value = false
          store.commit("setIsPending", false);
        } catch (err) {
          // isPending.value = false
          store.commit("setIsPending", false);
          // error.value = "Error: Game was not found..."
        }
      };
    }

    onUnmounted(() => {
      console.log("stopWatch");
      stopWatch()
    })


    return {
      user,
      teams,
      players,
      team1,
      team2,
      player1Id,
      player2Id,
      player3Id,
      player4Id,
      dealer,
      filtP2,
      filtP3,
      filtP4,
      player1,
      player2,
      player3,
      player4,
      lots,
      game,
      random,
      addLot,
      removeLot,
      addData,
      addTeam,
      handleP2change,
      handleP4change,
      handleReset,
      handleStart,
      randomGame,
      toggleAddTeam,
      toggleReset,
      toggleEndGame,
      startGame,
      scoreLot1,
      scoreLot2,
      dekaKalo,
      sum1,
      sum2,
      dekaP1,
      dekaP2,
      dekaP3,
      dekaP4,
      spinner,
      closeModal,
      closeResetModal,
      closeEndGameModal,
      error,
      isPending,
    };
  },
};
</script>
<style>
.diamond {
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-bottom-color: red;
  position: relative;
  top: -5px;
  display: inline-block;
}

.diamond:after {
  content: "";
  position: absolute;
  left: -5px;
  top: 5px;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-top-color: red;
}

.kalo {
  color: red;
}

.list-item {
  display: inline-block;
  margin-right: 10px;
}

.lot-enter-active {
  transition: all 1s ease;
}

.lot-enter-from {
  opacity: 0;
  transform: translateY(50px);
}

.lot-leave-to {
  opacity: 0;
  transform: translateX(50px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

input[type="number"]::placeholder {
  text-align: end;
}

input[type="number"] {
  min-width: 70px;
  text-align: end;
}

.w-40px {
  min-width: 40px;
}
</style>
